import { useSearchParams } from 'next/navigation';
import { useCallback, useRef } from 'react';

import { usePathname } from '../routing/routing';

/**
 * Unline useCurrentUrl doesn't subscribe to url changes
 * It provides a function to get currentUrl in runtime without rerendering
 */
export const useGetCurrentUrl = () => {
	const pathname = usePathname();
	const pathnameRef = useRef<string>(pathname);
	pathnameRef.current = pathname;

	const searchParams = useSearchParams();
	const searchParamsRef = useRef<URLSearchParams>(searchParams);
	searchParamsRef.current = searchParams;

	return useCallback(() => {
		return searchParamsRef.current?.size === 0
			? pathnameRef.current
			: `${pathnameRef.current}?${searchParamsRef.current}`;
	}, []);
};
